// extracted by mini-css-extract-plugin
export default {"fgLabel":"FormLabel_fgLabel__p2QX2","fgLabel_is_invalid":"FormLabel_fgLabel_is_invalid__MxoO1"};